// @sheerid/jslib doesn't polyfill for IE11 currently
import 'whatwg-fetch';
import 'url-search-params-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { setOptions, overrideComponent } from '@sheerid/jslib';
import App from './App';

// SheerID stuff
import { StepStudentPersonalInfoComponent } from './StepStudentPersonalInfoComponent';
import { StepPendingComponent } from './StepPendingComponent';
import { StepSuccessComponent } from './StepSuccessComponent';
import { defaultOptions } from './programOptions';
import { StepDocUploadComponent } from './StepDocUploadComponent';

setOptions(defaultOptions);

overrideComponent('StepSuccessComponent', StepSuccessComponent);
// @ts-ignore
overrideComponent('StepPendingComponent', StepPendingComponent);
// @ts-ignore
overrideComponent('StepStudentPersonalInfoComponent', StepStudentPersonalInfoComponent);

overrideComponent('StepDocUploadComponent', StepDocUploadComponent);
ReactDOM.render(<App />, document.getElementById('root'));
